import { render } from "./Player.vue?vue&type=template&id=4bf156bc&scoped=true&bindings={\"playerIndex\":\"props\",\"align\":\"props\",\"playerName\":\"options\",\"total\":\"options\",\"round\":\"options\",\"isWinning\":\"options\",\"isActive\":\"options\"}"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=4bf156bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4bf156bc"

export default script